import { useContext, useEffect, useState } from "react";
import {
  getQuickLinks,
  createQuickLink,
  updateQuickLink,
  deleteQuickLink,
} from "../services/configurations/quicklinks";
import { AppContext } from "../context";

type UseType = "DATA" | "ACTIONS";
type ActionType = "CREATE" | "UPDATE" | "DELETE";

const handleQuickLinkActionFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createQuickLink,
        fnMsg: t("Quicklinks.quicklinksApiCreateLabel"),
      };
    case "UPDATE":
      return {
        actionFn: updateQuickLink,
        fnMsg: t("Quicklinks.quicklinksApiUpdateLabel"),
      };
    case "DELETE":
      return {
        actionFn: deleteQuickLink,
        fnMsg: t("Quicklinks.quicklinksApiDeleteLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useQuickLinks = (type: UseType, quickLinkId?: number) => {
  const {
    t,
    toast,
    appState: { selectedApp },
    setAppState,
  } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);
  const appid = selectedApp?.appid || '0';

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const quickLinkAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleQuickLinkActionFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data, appid))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA" && appid) {
      (async function () {
        await Promise.resolve(getQuickLinks(appid))
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [appid, toast, reload, type, quickLinkId]);

  return {
    data,
    quickLinkAction,
    reloadFn,
  };
};
